module.exports = __webpack_public_path__ + "static/media/aws.163d09f0.jpg";